<ng-container *ngIf="statusModuleAssignments.length > 0; else noAssignment">
  <qai-item-grid
    *ngIf="isResponsiveLayoutEnabled"
    gap="24px"
    repeatCount="auto-fit"
    [minItemWidth]="displayAsRows ? '100%' : '380px'"
  >
    <app-assignment-card
      *ngFor="let assignment of statusModuleAssignments; trackBy: trackById"
      [assignment]="assignment"
    />
  </qai-item-grid>

  <div
    *ngIf="!isResponsiveLayoutEnabled"
    class="module-container"
    [ngClass]="{ 'single-row': displayAsRows }"
  >
    <div
      class="card"
      *ngFor="let statusModuleAssignment of statusModuleAssignments"
    >
      <div class="badge-container">
        <div
          *ngIf="
            statusModuleAssignment.moduleAssignmentProgressStatus !== 'COMPLETED' &&
              statusModuleAssignment.moduleAssignmentProgressStatus !== 'CERTIFIED' &&
              statusModuleAssignment.moduleAssignmentProgressStatus !== 'IN_COMPLETE' &&
              (statusModuleAssignment.moduleAssignmentProgressStatus || '').toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS &&
              (statusModuleAssignment.moduleAssignmentDTO.status || '').toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS &&
              daysUntilDuePill(statusModuleAssignment);
            let pill
          "
        >
          <div
            *ngIf="pill.pillColor && pill.pillText"
            class="pill"
            [ngClass]="pill.pillColor"
          >
            <img src="assets/icons/{{ pill.pillColor }}-pill-icon.svg" />
            <span>{{ pill.pillText }}</span>
          </div>
        </div>

        <div *ngIf="statusPilll(statusModuleAssignment); let pill">
          <div
            *ngIf="pill.pillColor && pill.pillText"
            class="pill"
            [ngClass]="pill.pillColor"
          >
            <img
              *ngIf="pill.pillColor !== 'incomplete'"
              src="assets/icons/{{ pill.pillColor }}-pill-icon.svg"
            />
            <span>{{ pill.pillText }}</span>
          </div>
        </div>
      </div>

      <div
        class="name"
        title="{{ statusModuleAssignment.moduleAssignmentDTO.name }}"
      >
        <span>{{ statusModuleAssignment.moduleAssignmentDTO.name }}</span>
      </div>
      <div class="date-badge-container">
        <div
          class="date"
          *ngIf="statusModuleAssignment.moduleAssignmentDTO.endDate"
        >
          <img src="assets/icons/calendar-icon.svg" />
          <span
            [title]="statusModuleAssignment.moduleAssignmentDTO.endDate | localeDate:'datetime'"
          >
            {{ statusModuleAssignment.moduleAssignmentDTO.endDate | localeDate:'date' }}
          </span>
        </div>
        <img
          *ngIf="statusModuleAssignment.moduleAssignmentDTO.endDate"
          class="ellipse"
          src="assets/icons/ellipse-icon.svg"
        />
        <div
          class="certification"
          title="{{
            statusModuleAssignment.moduleAssignmentDTO.moduleAssignmentType
          }}"
        >
          <img
            [src]="getModuleAssignmentIcon(
              statusModuleAssignment.moduleAssignmentDTO.moduleAssignmentType
            )"
            alt="{{ 'dashboard.MODULE_ASSIGNMENT_ALT' | transloco }}"
          />
          <span>{{
            statusModuleAssignment.moduleAssignmentDTO.moduleAssignmentType
              .charAt(0)
              .toUpperCase() +
              statusModuleAssignment.moduleAssignmentDTO.moduleAssignmentType
                .slice(1)
                .toLowerCase()
          }}</span>
        </div>
      </div>
      <div
        class="detail"
        title="{{ statusModuleAssignment.moduleAssignmentDTO.description }}"
      >
        <span>{{
          statusModuleAssignment.moduleAssignmentDTO.description
        }}</span>
      </div>
      <div class="buttons">
        <div
          class="button"
          [ngClass]="
            isAssignmentAvailable(statusModuleAssignment)
              ? 'active'
              : 'inactive'
          "
          (click)="
            sendAmplitudeClickViewAssignmentEvent(statusModuleAssignment);
            isAssignmentAvailable(statusModuleAssignment) &&
              goToAssignment(statusModuleAssignment)
          "
        >
          <span>{{'dashboard.VIEW_ASSIGNMENT' | transloco}}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noAssignment>
  <qai-empty [title]="noAssignmentTitle" [description]="noAssignmentDetails">
    <qai-glyph
      qaiSlot="glyph"
      spotlight="brand"
      kind="assignment"
      size="80px"
    />
  </qai-empty>
</ng-template>
